import { Navigate, Route, Routes } from "react-router-dom";
import CreateBloggerPage from "../pages/CreateBloggerPage";
import BloggersPage from "../pages/BloggersPage";
import EditBloggerPage from "../pages/EditBloggerPage";
import SearchTasksPage from "../pages/SearchTasksPage";
import SearchTaskPage from "../pages/SearchTaskPage";
import NotificationsPage from "../pages/NotificationsPage";
import { Box } from "@mui/material";
import AppBar from "../AppBar";
import PublicRelationsPage from "../pages/PublicRelationsPage";
import PublicRelationPage from "../pages/PublicRelationPage";
import PublicRelationEditPage from "../pages/PublicRelationEditPage";
import { TemplatesPage } from "../pages/TemplatesPage";
import { TemplatePage } from "../pages/TemplatePage";
import StudiosPage from "../pages/studios/StudiosPage";
import CreateStudioPage from "../pages/studios/CreateStudioPage";
import EditStudioPage from "../pages/studios/EditStudioPage";
import LeadsPage from "../pages/leads/LeadsPage";
import CreateLeadPage from "../pages/leads/CreateLeadPage";
import EditLeadPage from "../pages/leads/EditLeadPage";
import AiAgentsPage from "../pages/aiagents/AiAgentsPage";
import CreateAiAgentPage from "../pages/aiagents/CreateAiAgentPage";
import EditAiAgentPage from "../pages/aiagents/EditAiAgentPage";
import EmailSchedulersPage from "../pages/emailSchedulers/EmailSchedulersPage";
import CreateEmailSchedulerPage from "../pages/emailSchedulers/CreateEmailSchedulerPage";
import EditEmailSchedulerPage from "../pages/emailSchedulers/EditEmailSchedulerPage";


export const ManagerView = () => (
  <>
  <AppBar pages={
    [
      {
        label: 'Bloggers',
        route: '/bloggers'
      },
      {
        label: 'Search tasks',
        route: '/search-tasks'
      },
      {
        label: 'PR',
        route: '/pr'
      },
      {
        label: 'Studios',
        route: '/studios'
      },
      {
        label: 'Leads',
        route: '/leads'
      },
      {
        label: 'AI Agents',
        route: '/aiagents'
      },
      {
        label: 'Notifications',
        route: '/notifications'
      },
      {
        label: 'Templates',
        route: '/templates'
      },
      {
        label: 'Studios',
        route: '/studios'
      },
      {
        label: 'Email Schedulers',
        route: '/email-schedulers'
      }
    ]
  }/>
  <Box sx={{ p: 3, flexGrow: 1, minHeight: 0, overflow: 'auto'}}>
    <Routes>
      <Route path="/" element={<Navigate to="/bloggers" />}></Route>

      <Route path="/bloggers" element={<BloggersPage/>}></Route>
      <Route path="/bloggers/new" element={<CreateBloggerPage/>}></Route>
      <Route path="/bloggers/:id" element={<EditBloggerPage/>}></Route>

      <Route path="/search-tasks" element={<SearchTasksPage/>}></Route>
      <Route path="/search-tasks/new" element={<SearchTaskPage/>}></Route>
      <Route path="/search-tasks/:id" element={<SearchTaskPage/>}></Route>

      <Route path="/pr" element={<PublicRelationsPage/>}></Route>
      <Route path="/pr/new" element={<PublicRelationPage />}></Route>
      <Route path="/pr/:id" element={<PublicRelationEditPage />}></Route>

      <Route path="/notifications" element={<NotificationsPage/>}></Route>

      <Route path="/templates" element={<TemplatesPage/>}></Route>
      <Route path="/templates/new" element={<TemplatePage/>}></Route>
      <Route path="/templates/:id" element={<TemplatePage/>}></Route>

      <Route path="/studios" element={<StudiosPage/>}></Route>
      <Route path="/studios/new" element={<CreateStudioPage/>}></Route>
      <Route path="/studios/:id" element={<EditStudioPage/>}></Route>

      <Route path="/leads" element={<LeadsPage/>}></Route>
      <Route path="/leads/new" element={<CreateLeadPage/>}></Route>
      <Route path="/leads/:id" element={<EditLeadPage/>}></Route>

      <Route path="/aiagents" element={<AiAgentsPage/>}></Route>
      <Route path="/aiagents/new" element={<CreateAiAgentPage/>}></Route>
      <Route path="/aiagents/:id" element={<EditAiAgentPage/>}></Route>

      <Route path="/email-schedulers" element={<EmailSchedulersPage/>}></Route>
      <Route path="/email-schedulers/new" element={<CreateEmailSchedulerPage/>}></Route>
      <Route path="/email-schedulers/:id" element={<EditEmailSchedulerPage/>}></Route>
    </Routes>
  </Box>
  </>
)